import { Jaco3dMixin } from "./Jaco3d";
import { monkeyPatchScene } from "./ModelGhost3dInstancedMesh";

import type { ModelGhost } from "../arrangement/ModelGhost";
import type { Model3d } from "./Model3d";
import { Group } from "three";

monkeyPatchScene();

/**
 * synchronisierte Darstellungs-Kopie eines Model3d, deren Position und Orientierung individuell, aber deren
 * Geometrie und Material als Referenz-Kopie vom Original übernommen ist.
 */
export class ModelGhost3d extends Jaco3dMixin(Group) {
  instances: any = null;
  _update3dCounter: number = 0;
  isModelGhost3d: boolean = true;

  // Narrowing jaco type
  declare jaco: ModelGhost;

  /**
   * Creates an instance of ModelGhost3d.
   */
  constructor(...args: any[]) {
    // @ts-ignore
    super(...args);
  }

  get model3d(): Model3d | null | undefined {
    return this.jaco.model?.jaco3d as Model3d | null | undefined;
  }

  getMeta() {
    return this.jaco.model?.getMeta();
  }

  get key() {
    return this.jaco.model?.key;
  }

  get modelMaterialRelation() {
    return this.jaco.model?.modelMaterialRelation;
  }

  update3d() {
    const model3d = this.model3d;
    if (model3d) {
      this._update3dCounter = Math.max(model3d._update3dCounter, this._update3dCounter + 1);
      if (model3d._update3dCounter < this._update3dCounter) {
        model3d.update3d();
        model3d._update3dCounter = this._update3dCounter;
      }
    }
    super.update3d();
  }
}
